module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/wedding-mobile@2x-99be175c24f7c6605eeddaef703ad1aa.jpg";